module.exports = __webpack_public_path__ + "static/media/kaporg-icon-white.03c0f8cf.svg";